import {
  RapidlyExpandingCommunitySolid,
  PresentationBoard,
  SoftwareDevelopmentIcon,
  ThumbUpOutlined,
  UsersOutline,
  CheckSquare,
  HealthcareIcon,
  AutomobileIcon,
  FinanceAndBankingIcon,
  EducationIcon,
  ManufacturingIcon,
  RetailIcon,
  GovernmentIcon,
  SupplyChainIcon,
  Flash6737345,
} from "@spoctech/icons";

const COURSE_CARD_DUMMY = {
  coverSrc:
    "https://images.unsplash.com/photo-1552083375-1447ce886485?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  tag: "Trending",
  title: "Agile scrum foundation",
  description: `Spoclearn delivers Agile & Scrum training for many popular courses 
      including Scrum Master certification Spoclearn delivers Agile & Scrum
      training for many popular courses including Scrum Master certification
      Spoclearn delivers Agile & Scrum training for many popular courses
      including Scrum Master certification`,
  totalEnroll: "1000",
  ratings: "4.3",
  topicsCovered: "9",
  topics: ["Scrum Roles", "Agility", "Scrum Roles", "Agility"],
  author: "Keerthi Shivakumar",
  date: "30 Jan 2024",
  duration: "20 Min read",
};

const LEARNER_CARD_DUMMY = {
  src: "http://localhost:3000/images/learner-1.jpg",
  feedback: `“The Data Science course was fantastic! The instructors were
    excellent, the hands-on projects were really helpful, and I feel
    more confident in my skills now “The Data Science course was
    fantastic!"`,
  name: "Ashok",
  designation: "Software Developer at Infosys",
};

const CATAEGOTY_CARD_DUMMY = {
  courses: ["Scrum Roles", "Agility", "Scrum Roles", "Agility"],
  title: "Agile and Scrum",
  totalCourses: "4",
  description:
    "Learn from certified and experienced instructors in a traditional classroom setting.",
};

const COURSES = [
  COURSE_CARD_DUMMY,
  {
    ...COURSE_CARD_DUMMY,
    title: "Project Management",
  },
  COURSE_CARD_DUMMY,
  COURSE_CARD_DUMMY,
  COURSE_CARD_DUMMY,
  COURSE_CARD_DUMMY,
  COURSE_CARD_DUMMY,
  COURSE_CARD_DUMMY,
];

const LEARNERS = [
  LEARNER_CARD_DUMMY,
  LEARNER_CARD_DUMMY,
  LEARNER_CARD_DUMMY,
  LEARNER_CARD_DUMMY,
  LEARNER_CARD_DUMMY,
  LEARNER_CARD_DUMMY,
];

const CATEGORIES = [
  {
    ...CATAEGOTY_CARD_DUMMY,
    icon: PresentationBoard,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Project Management",
    icon: PresentationBoard,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Microsoft courses",
    icon: RapidlyExpandingCommunitySolid,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Development & Testing",
    icon: RapidlyExpandingCommunitySolid,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "AI & ML",
    icon: RapidlyExpandingCommunitySolid,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Digital Marketing",
    icon: RapidlyExpandingCommunitySolid,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Development & Testing",
    icon: RapidlyExpandingCommunitySolid,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Microsoft courses",
    icon: RapidlyExpandingCommunitySolid,
  },
];

const SPOCLEARN_OFFERS = [
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Classroom training",
    // icon: ClassroomTrainingIcon,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Live virtual training",
    // icon: LiveVirtualTrainingIcon,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "Corporate group training",
    // icon: CorporateGroupTrainingIcon,
  },
  {
    ...CATAEGOTY_CARD_DUMMY,
    title: "One-to-one training",
    // icon: OneToOneTrainingIcon,
  },
];
//Consulting data

const WHY_CHOOSE_SPOCLEARN = [
  {
    description:
      "Our team of experts brings in-depth knowledge, industry insights, and a commitment to your success.",
    title: "Expert Team Members",
    icon: UsersOutline,
  },
  {
    description:
      "We partner with you to ensure your business thrives  in every aspect.",
    title: "Partner With  Us",
    icon: ThumbUpOutlined,
  },
  {
    description:
      "Together, we all navigate the complexities of your business environment and chart a course towards lasting success.",
    title: "Achieving Lasting Success",
    icon: CheckSquare,
  },
];

const CUSTOMIZED_CONSULTING_INDUSTRY = [
  {
    title: "Technology and Software Development",
    icon: SoftwareDevelopmentIcon,
  },
  {
    title: "Healthcare",
    icon: HealthcareIcon,
  },
  {
    title: "Automobile",
    icon: AutomobileIcon,
  },
  {
    title: "Finance and Banking",
    icon: FinanceAndBankingIcon,
  },
  {
    title: "Education",
    icon: EducationIcon,
  },
  {
    title: "Manufacturing",
    icon: ManufacturingIcon,
  },
  {
    title: "Retail",
    icon: RetailIcon,
  },
  {
    title: "Government",
    icon: GovernmentIcon,
  },
  {
    title: "Logistics and Supply Chain",
    icon: SupplyChainIcon,
  },
  {
    title: "Energy and Utilities",
    icon: Flash6737345,
  },
];

// Webinar data
const WEBINAR_CARD_DUMMY = {
  coverSrc:
    "https://images.unsplash.com/photo-1552083375-1447ce886485?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  tag: "Data Analytics",
  title: "Agile scrum foundation",
  author: "Keerthi Shivakumar",
  date: "30 Jan 2024",
  time: "09:00 AM - 05:00 PM",
};

const WEBINAR = [
  WEBINAR_CARD_DUMMY,
  {
    ...WEBINAR_CARD_DUMMY,
    title: "Project Management",
  },
  WEBINAR_CARD_DUMMY,
  {
    ...WEBINAR_CARD_DUMMY,
    title: "DevOps",
  },
  WEBINAR_CARD_DUMMY,
  WEBINAR_CARD_DUMMY,
  WEBINAR_CARD_DUMMY,
  WEBINAR_CARD_DUMMY,
  WEBINAR_CARD_DUMMY,
];

export {
  COURSES,
  LEARNERS,
  CATEGORIES,
  SPOCLEARN_OFFERS,
  WHY_CHOOSE_SPOCLEARN,
  CUSTOMIZED_CONSULTING_INDUSTRY,
  WEBINAR,
};
